import {useState, useEffect, useRef} from "react";
import {useParams} from "react-router-dom";
import axios from "axios";
import {base, projects_url, currency} from "../../api";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {Toast} from "primereact/toast";
import EditProject from "./EditProject";
import BudgetProjects from "./Components/Budget/BudgetProjects";

import ExpancesProjectsMounthly from "./Components/Budget/ExpancesProjectsMounthly";

export default function SingleProject() {
	const {id} = useParams();
	const [state, setState] = useState();
	const [editCurrentProject, setEditCurrentProject] = useState(false);
	const [contentLoadTrigger, setContentLoadTrigger] = useState();
	const [currencySymbol, setCurrencySymbol] = useState(false);
	const toast = useRef(null);

	useEffect(() => {
		setCurrencySymbol(false);
	}, [contentLoadTrigger]);

	useEffect(() => {
		axios.all([axios.get(base + projects_url + id + "/"), axios.get(base + currency)]).then(
			axios.spread((...response) => {
				setState(response[0]?.data);
				setCurrencySymbol(response[1]?.data);
			}),
		);
	}, [editCurrentProject, id]);

	const formatDate = dateString => {
		if (!dateString) return "---";
		const date = new Date(dateString);
		return new Intl.DateTimeFormat("ru-RU").format(date);
	};

	return (
		<div className="col-12 p-0">
			<Toast ref={toast} />
			<Dialog
				header="Նախագծի խմբագրում"
				visible={editCurrentProject}
				style={{width: "60vw"}}
				onHide={() => setEditCurrentProject(false)}
				modal
				dismissableMask>
				{editCurrentProject && (
					<EditProject
						setEditCurrentProject={val => {
							setEditCurrentProject(val);
							if (!val) {
								setContentLoadTrigger(Date.now());
								toast.current.show({
									severity: "info",
									summary: "Նախագիծ",
									detail: "Փոփոխությունները պահպանվեցին կամ չեղարկվեցին",
								});
							}
						}}
						projectID={state?.id}
					/>
				)}
			</Dialog>

			{!editCurrentProject && (
				<div>
					<div className="row">
						<div className="col-12">
							<div className="card rounded shadow-lg p-3">
								<div className="col-md-12 p-0">
									<div className="d-flex align-items-center">
										<div className="col-9 p-3">
											<div className="d-grid align-items-center">
												<div className="fs-4 fw-bold me-3 mb-1">{state?.number}</div>
												<div className="d-flex align-items-center text-uppercase">
													{state?.completed ? (
														<div className="text-danger">
															<span className="small">Ծրագիրն ընթացքում է</span>
														</div>
													) : (
														<div className="text-success">
															<span className="small">Ծրագիրն ավարտված է</span>
														</div>
													)}
												</div>
											</div>
										</div>
										<div className="col-md-3 text-end">
											<Button
												label="Խմբագրել"
												icon="pi pi-pencil"
												className="me-2"
												rounded
												onClick={e => setEditCurrentProject(true)}></Button>
										</div>
									</div>
									<hr />
								</div>

								<div className="row p-0 m-0">
									<div className="col-lg-6 col-12">
										<div className="col-12">
											<div className="small opacity-75 d-flex align-items-center">
												Հայերեն անվանումը
											</div>
											<div className="fw-bolder d-flex align-items-center pb-2">
												{state?.full_name_am}
											</div>
										</div>
										<div className="col-12">
											<div className="small opacity-75 d-flex align-items-center">
												Անգլերեն անվանումը
											</div>
											<div className="fw-bolder d-flex align-items-center pb-2">
												{state?.full_name_en}
											</div>
										</div>
										<div className="col-12">
											<div className="small opacity-75 d-flex align-items-center">
												Կարճ անվանումը
											</div>
											<div className="fw-bolder d-flex align-items-center pb-2">{state?.name}</div>
										</div>
									</div>
									<div className="col-lg-6 col-12">
										<div className="col-12">
											<div className="small opacity-75 d-flex align-items-center">
												Ծրագրի սկիզբ և ավարտ
											</div>
											<div className="d-flex align-items-center fw-bold">
												{state?.start_date ? formatDate(state.start_date) : "---"} -{" "}
												{state?.end_date ? formatDate(state.end_date) : "---"}
											</div>
										</div>
										<div className="col-12">
											<div className="small opacity-75 d-flex align-items-center">
												Արտարժույթ / Փոխարժեք
											</div>
											<div className="d-flex align-items-center fw-bold">
												{state?.currency_value ? (
													<span>
														{parseFloat(state.currency_value).toLocaleString("hy-AM", {
															maximumFractionDigits: 1,
														})}{" "}
														֏
													</span>
												) : (
													<span className="text-muted">Արտարժույթը նշված չէ</span>
												)}
											</div>
										</div>
										<div className="col-12">
											<div className="small opacity-75 d-flex align-items-center">
												Սեփական ներդրում
											</div>
											<div className="d-flex align-items-center fw-bold text-primary">
												{parseFloat(state?.own_contribution).toLocaleString("hy-AM", {
													maximumFractionDigits: 0,
												})}{" "}
												֏
											</div>
										</div>
										<div className="col-12">
											<div className="small opacity-75 d-flex align-items-center">
												Դրամաշնորի ներդրում
											</div>
											<div className="d-flex align-items-center fw-bold text-success">
												{parseFloat(state?.grant_amount).toLocaleString("hy-AM", {
													maximumFractionDigits: 0,
												})}{" "}
												֏
											</div>
										</div>
									</div>

									<div className="col-12 p-0 px-3">
										<div className="d-flex align-items-center fw-bold">Նկարագրություն</div>
										<div className="mt-2">{state?.description}</div>
										{state?.yearly_expenses?.length > 0 && (
											<div className="col-12 mt-3">
												<div className="d-flex align-items-center fw-bold mb-2">Տարեկան ծախսեր</div>
												<ul className="list-group">
													{state.yearly_expenses.map(expense => (
														<li
															key={expense.id}
															className="list-group-item d-flex justify-content-between align-items-center px-3 py-2">
															<span>Տարի՝ {expense.year}</span>
															<span>
																{parseFloat(expense.expenses).toLocaleString("hy-AM", {
																	maximumFractionDigits: 0,
																})}{" "}
																֏
															</span>
														</li>
													))}
												</ul>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}

			<BudgetProjects
				projectID={id}
				project={state}
				setContentLoadTrigger={setContentLoadTrigger}
			/>

			<ExpancesProjectsMounthly
				projectID={id}
				project={state}
				contentLoadTrigger={contentLoadTrigger}
				currency_value={state?.currency_value}
			/>
		</div>
	);
}
